import willen from "../../assets/marshall/ms1.png";
import embertonII from "../../assets/marshall/ms2.png";
import emberton from "../../assets/marshall/ms3.png";
import stockwellII from "../../assets/marshall/ms4.png";
import kilburnII from "../../assets/marshall/ms5.png";
import tufton from "../../assets/marshall/ms6.png";
import speaker1 from "../../assets/BestInCate/speaker1.jpeg";
import speaker3 from "../../assets/BestInCate/speaker3.jpeg";

const portableSpeakers = [
  {
    type: "speakers",
    id: 1,
    picture: willen, // replace with actual image import
    productName: "WILLEN",
    punchLine: "MIGHTY SOUND, EVERYWHERE",
    playtime: "15+ hours of portable playtime",
    productDescription:
      "Willen is the mighty portable speaker that is made to go everywhere with you. Built with one 2” full range driver and two passive radiators, this speaker brings you the heavy Marshall sound you can’t live without. A top-of-class IP67 dust- and water-resistance rating means it’s always ready for the road. Its rugged design and handy mounting strap make it perfect for your adventurous lifestyle.",
    price: "14,999",
    features: [
      "15+ hours of playtime",
      "Bluetooth 5.1",
      "IP67 waterproof and dustproof",
      "Compact and rugged design",
      "Stack Mode for multi-speaker pairing",
      "Mounting strap for versatility",
    ],
    colors: ["BLACK", "CREAM"],
    path: "/marshall/details/speakers/1",
  },
  {
    type: "speakers",
    id: 2,
    picture: embertonII, // replace with actual image import
    productName: "EMBERTON II",
    punchLine: "LOUDER, STRONGER, LONGER",
    playtime: "30+ hours of portable playtime",
    productDescription:
      "Emberton II delivers sound that is rich, clear and loud, like the artist intended. A true portable speaker with superior signature Marshall sound. Experience absolute 360° sound with True Stereophonic, and take it anywhere thanks to a robust IP67 dust- and water-resistance rating. With 30+ hours of portable playtime, Emberton II keeps the music going for longer without compromising on performance or durability.",
    price: "19,999",
    features: [
      "30+ hours of playtime",
      "Bluetooth 5.1",
      "True Stereophonic 360° sound",
      "IP67 waterproof and dustproof",
      "Stack Mode for multi-speaker pairing",
      "Compact and durable design",
    ],
    colors: ["BLACK AND BRASS", "CREAM"],
    path: "/marshall/details/speakers/2",
  },

  {
    type: "speakers",
    id: 3,
    picture: tufton, // replace with your actual image import
    productName: "TUFTON",
    punchLine: "KING OF THE ROAD",
    playtime: "20+ hours of portable playtime",
    productDescription:
      "Bring the show on the road with Tufton, the mightiest portable speaker from Marshall. Tufton packs 20+ hours of portable playtime, allowing you to go further, for longer. Engineered as a 3-way system, it produces a clear and articulate sound across all frequencies. An additional mid-range driver is located on the rear of the speaker to give the listener a true 360° Blumlein stereo sound experience.",
    price: "39,999",
    features: [
      "20+ hours of playtime",
      "Bluetooth 5.0",
      "3-way sound system",
      "360° Blumlein stereo sound",
      "IPX2 water-resistant",
      "Durable metal grille and rugged design",
    ],
    colors: ["BLACK", "BRASS"],
    path: "/marshall/details/speakers/3",
  },
  {
    type: "speakers",
    id: 4,
    picture: emberton, // replace with your actual image import
    productName: "EMBERTON",
    punchLine: "PACKS A PUNCH",
    playtime: "20+ hours of portable playtime",
    productDescription:
      "Emberton is a compact portable speaker with the loud and vibrant sound only Marshall can deliver. Utilising True Stereophonic, a unique form of multi-directional sound, it provides absolute 360° sound where every spot is a sweet spot. With 20+ hours of playtime and IPX7 water resistance, Emberton is your go-to travel buddy for bold sound and durability.",
    price: "17,999",
    features: [
      "20+ hours of playtime",
      "True Stereophonic (360° sound)",
      "Compact and lightweight (0.7 kg)",
      "IPX7 waterproof",
      "Durable metal grille",
      "Iconic Marshall design",
    ],
    colors: ["BLACK", "BRASS", "CREAM"],
    path: "/marshall/details/speakers/4",
  },
  {
    type: "speakers",
    id: 5,
    picture: stockwellII, // replace with your actual image import
    productName: "STOCKWELL II",
    punchLine: "TRAVELS LIGHT, SOUNDS HEAVY",
    playtime: "20+ hours of portable playtime",
    productDescription:
      "Built for life on the road, this compact portable speaker offers 20+ hours of playtime. Weighing only 1.4 kg, Stockwell II packs a solid punch despite its pint-sized frame. Utilising Blumlein stereo sound construction, this speaker provides a multi-directional experience that will immerse you in your music, indoors or out. Three class D amplifiers power its subwoofer, front and rear facing tweeters, for a sound that’s brilliantly powerful and clear. In addition, Bluetooth® 5.0 technology allows you to connect to a variety of wireless devices with a range of 30 ft.",
    price: "22,999",
    features: [
      "20+ hours of playtime",
      "Bluetooth 5.0",
      "Blumlein stereo sound",
      "Multi-directional audio",
      "IPX4 water-resistant",
      "Compact and travel-ready design",
    ],
    colors: ["BLACK", "GREY"],
    path: "/marshall/details/speakers/5",
  },
  {
    type: "speakers",
    id: 6,
    picture: kilburnII,
    productName: "KILBURN II",
    punchLine: "A STOUT-HEARTED HERO",
    playtime: "20+ hours of portable playtime",
    productDescription:
      "Free from the confines of wires and cords, this Bluetooth speaker offers 20+ hours of portable playtime on a single charge. This stout-hearted hero weighs only 2.5 kg and is the loudest speaker in its class. It produces a clear midrange, deep bass and extended highs that are unrivalled for a speaker this size, and its multi-directional sound will immerse you in your music, indoors or out.",
    price: "27,999",
    features: [
      "20+ hours of playtime",
      "Bluetooth 5.0",
      "Multi-directional sound",
      "Flush mounted corner caps",
      "Water-resistant design",
      "Guitar-inspired carrying strap",
    ],
    colors: ["BLACK", "BURGUNDY"],
    path: "/marshall/details/speakers/6",
  },
  {
    type: "speakers",
    id: 7,
    picture: speaker1,
    productName: "WOBURN III",
    punchLine: "THE HEAVYWEIGHT CHAMPION OF SOUND",
    playtime: "Mains powered",
    productDescription:
      "Woburn III is the biggest speaker in the Marshall home line-up. This powerful home speaker is designed to deliver room-filling sound with deep, powerful bass and crystal-clear highs. With its iconic Marshall design and premium build quality, Woburn III brings the legendary Marshall sound to your home. Features next-generation Bluetooth technology and multiple connectivity options.",
    price: "59,999",
    features: [
      "Powerful home audio system",
      "Bluetooth 5.2",
      "Multiple connectivity options",
      "Premium build quality",
      "Iconic Marshall design",
      "Room-filling sound",
    ],
    colors: ["BLACK"],
    path: "/marshall/details/speakers/7",
  },
  {
    type: "speakers",
    id: 8,
    picture: speaker3,
    productName: "STANMORE III",
    punchLine: "COMPACT POWERHOUSE",
    playtime: "Mains powered",
    productDescription:
      "Stanmore III is the most versatile speaker in the Marshall home line-up. This compact active stereo speaker packs a solid punch, delivering powerful sound with deep bass and clear highs. With its iconic Marshall design and next-generation Bluetooth technology, Stanmore III brings the legendary Marshall sound to any room in your home. Features multiple connectivity options for maximum flexibility.",
    price: "41,999",
    features: [
      "Compact home audio system",
      "Bluetooth 5.2",
      "Multiple connectivity options",
      "Active stereo speaker",
      "Iconic Marshall design",
      "Powerful sound in compact form",
    ],
    colors: ["BLACK"],
    path: "/marshall/details/speakers/8",
  },
];

export default portableSpeakers;
